import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import DemandForm from "../components/demand/DemandForm";
import DemandList from "../components/demand/DemandList";
import DemandDetail from "../components/demand/DemandDetail";
import ReputationTable from "../components/demand/ReputationTable";
import { hasPerm } from "../lib/perms";
import { useAuth } from "../lib/auth";
import api from "../lib/api";
import { Briefcase, Award, Plus } from "lucide-react";

export default function DemandBoard() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState("demands");
  const [showForm, setShowForm] = useState(params.get("new") === "1");
  const [prefill, setPrefill] = useState(() => params.get("new") === "1" ? { game_id: params.get("game_id") || "", server_id: params.get("server_id") || "",
    faction: params.get("faction") || "", item_name: params.get("item") || "",
    invited: params.getAll("inv").map((id, i) => ({ id, name: params.getAll("invn")[i] || "Supplier" })) } : null);
  const [refresh, setRefresh] = useState(0);
  const [games, setGames] = useState([]);
  const [servers, setServers] = useState([]);
  const openId = params.get("job");

  useEffect(() => {
    api.get("/games").then((r) => setGames(r.data));
    api.get("/servers").then((r) => setServers(r.data));
    if (params.get("new") === "1") setParams({}, { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!hasPerm(user, "manage_demand")) return (
    <div className="min-h-screen bg-[#101114]"><Header /><div data-testid="demand-forbidden" className="p-10 text-[#A8A8AD]">Anda tidak memiliki izin Kelola Demand.</div></div>
  );
  const tabBtn = (key, label, Icon) => (
    <button data-testid={`demand-tab-${key}`} onClick={() => setTab(key)}
      className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${tab === key ? "border-[#D4AF37] text-[#D4AF37]" : "border-transparent text-[#A8A8AD] hover:text-[#F5F3ED]"}`}>
      <Icon size={15} /> {label}
    </button>
  );
  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-2">JOB / DEMAND BOARD</div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[#F5F3ED]" style={{ fontFamily: "'Playfair Display', serif" }}>Cari Seller untuk Kebutuhan Stok</h1>
          </div>
          {tab === "demands" && (
            <button data-testid="demand-new-btn" onClick={() => { setPrefill(null); setShowForm((v) => !v); }}
              className="flex items-center gap-2 bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] font-bold rounded-sm px-5 py-2.5 text-sm transition-colors">
              <Plus size={16} /> Buat Demand
            </button>
          )}
        </div>
        <div className="flex gap-1 mb-8 border-b border-[#35353B]">{tabBtn("demands", "Demand", Briefcase)}{tabBtn("reputation", "Reputasi Supplier", Award)}</div>
        {tab === "demands" ? (
          <>
            {showForm && <DemandForm key={prefill ? "prefill" : "empty"} games={games} servers={servers} initial={prefill} onCreated={(d) => { setShowForm(false); setPrefill(null); setRefresh((x) => x + 1); setParams({ job: d.id }); }} />}
            <DemandList games={games} servers={servers} refresh={refresh} onOpen={(id) => setParams({ job: id })} />
          </>
        ) : <ReputationTable />}
      </div>
      {openId && <DemandDetail id={openId} onClose={() => setParams({})} onChanged={() => setRefresh((x) => x + 1)} />}
    </div>
  );
}
